export default {
	//手机品牌
    phone_data: ['华为', '小米', 'VIVO','魅族','OPPO','三星','金立','努比亚','联想','其它'],
	//已安装APP定向
	app_directional: ['购物','阅读','新闻','视频','旅游','工具','社交','音乐','美化','摄影','理财','系统','生活','出行','安全','教育','健康','娱乐','儿童','办公','通讯','游戏传奇类','游戏奇迹类','游戏棋牌类','游戏仙侠类','游戏休闲类','游戏西游类','游戏三国类'],
	//已安装APP排除
	/*app_exclude: ['手机百度', '葫芦娃贪吃蛇', '贷款类应用', 'P2P类应用', 'JJ斗地主', '植物大战僵尸2', '和彩云', '腾讯麻将来了', '传奇来了', '热血传奇', '传奇世界手游', 
					'王者传奇', '传奇私服(激情版)', '传奇霸业手游', '屠魔传奇', '大天使之间H5', '机器：觉醒', '全民奇迹', '暗黑血源：机甲战神', '腾讯欢乐麻将全集', '欢乐麻将(升级版)',
					, '四川麻将血战到底', '欢乐斗地主', '途游斗地主', '天天斗地主', '天天斗地主HD', '单机斗地主', '天天象棋', '单机斗地主', '天天德州扑克', '仙剑奇侠传 官方手游', '全民斩仙', 
					'新剑侠情缘', '御剑情缘：国风新世界', '蜀山战纪', '秦时明月', '诛仙(王俊凯代言)', '青云志', '天天爱消除', '开心消消乐', '节奏大师', '球球大作战', '消灭星星全新版', '宾果消消乐', 
					'节奏大师', '梦幻西游', '欢乐西游', '少年西游记', '造梦西游OL', '傲世西游', '三国之刃', '放开那三国(送貂蝉)', '放开那三国2', '三国传说', '三国点将', '三国枭雄', '决战三国', 
					'三国世界', '腾讯手机管家-清理垃圾防骚扰', 'QQ安全中心', 'KingRoot(一键权限获取,授权管理)', '百度手机卫士', '手机毒霸', 'LBE安全大师(免Root)', '乐安全', '天翼用户中心(手机管家卫士)', 
					'网易将军令', '手机加速神器', '手机安全先锋(原：杀毒先锋)', '手机安全卫士', 'YY安全中心', '安医生', '云杀毒', '蓝盾安全卫士', '顽固木马专杀', '摩安卫士手机安全支持双模', '安卓卫士', 
					'王泰安全', '免费WIFI密码查看', '安全卫士', '私密空间', 'V380', '移动手机卫士', '叨鱼', '瑞星手机安全软件', '安全卫士', '手机卫士', '战网手机令牌', '私密相册', '淘宝安全中心', 
					'程序锁', 'avast!手机安全', 'AVG杀毒', '锁大师', '玲珑密保锁', '创保网', '卡巴斯基手机安全软件', '蜗牛二手货车', 'Mydol', '程序加密', '应用锁', 'YYP2P', '手机密令', '联通手机卫士', 
					'AVG杀毒软件', '手机管家', '刷机精灵授权管理', '权限杀手专杀工具', '汉邦一点通Pro', '防病毒和手机安全', '百度安全中心', '安卓手机程序加密', '隐私空间', '最美IOS8主题锁屏', '大蜘蛛杀毒软件', 
					'呼死你终结者', '新浪微盾', '文件隐藏专家', '腾讯Pad管家HD', 'LBE隐私卫士', '海卓隐私管家', '监控大师'] */
	
	//兴趣定向
    interest_orientation: ['娱乐', '社会', '财经','军事','体育','游戏','科技','女性','国内','国际', '汽车', '教育', '房产', '时尚', '微看点', '笑话', '历史', '健康', '星座', '家具', '自然', '情感', '宠物', 
							'动漫', '育儿', '本地政务', '电影', '电视剧', '演出', '绯闻', '保健', '健身', '心理', '饮食', '减肥'],
	
	
	
	
}
